import React from 'react';

export default function ManualPage(props) {
  return (
    <div className="manual">
      <props.component />
    </div>
  );
}
